var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBudgetsummarylogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.6426 1.25464H14.2141M23.6426 6.3975H14.2141M23.6426 11.5404H14.2141M23.6426 21.8261H14.2141M23.6426 16.6832H14.2141M1.35693 2.11178V8.96892C1.35693 9.44231 1.74069 9.82607 2.21408 9.82607H9.07122C9.5446 9.82607 9.92836 9.44231 9.92836 8.96892V2.11178C9.92836 1.6384 9.5446 1.25464 9.07122 1.25464H2.21408C1.74069 1.25464 1.35693 1.6384 1.35693 2.11178ZM1.35693 14.1118V20.9689C1.35693 21.4422 1.74069 21.8261 2.21408 21.8261H9.07122C9.5446 21.8261 9.92836 21.4422 9.92836 20.9689V14.1118C9.92836 13.6384 9.5446 13.2546 9.07122 13.2546H2.21408C1.74069 13.2546 1.35693 13.6384 1.35693 14.1118Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudgetsummarylogo);
export default __webpack_public_path__ + "static/media/budgetsummarylogo.2cdd10dcb02e0fef6a76ed9858c2df1b.svg";
export { ForwardRef as ReactComponent };